<template>
    <div :class="color ? 'not-fill' : 'fill'">
        <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.79209 10.0289C7.70848 9.94617 7.63405 9.85464 7.57009 9.75592L0.982094 3.28791C0.830005 3.13894 0.709173 2.96111 0.626686 2.76484C0.544199 2.56857 0.501709 2.35781 0.501709 2.14492C0.501709 1.93202 0.544199 1.72126 0.626686 1.52499C0.709173 1.32873 0.830005 1.15089 0.982094 1.00191C1.29361 0.698152 1.71149 0.528137 2.14659 0.528137C2.58169 0.528137 2.99957 0.698152 3.31109 1.00191L8.98509 6.57191L14.6851 0.971916C14.9966 0.668153 15.4145 0.498138 15.8496 0.498138C16.2847 0.498138 16.7026 0.668153 17.0141 0.971916C17.1668 1.12054 17.2882 1.29826 17.371 1.49458C17.4539 1.69089 17.4966 1.90182 17.4966 2.11492C17.4966 2.32801 17.4539 2.53894 17.371 2.73526C17.2882 2.93157 17.1668 3.10929 17.0141 3.25792L10.3951 9.75792C10.3313 9.85676 10.2568 9.9483 10.1731 10.0309C9.84954 10.3331 9.42332 10.5012 8.98059 10.5012C8.53786 10.5012 8.11164 10.3331 7.78809 10.0309L7.79209 10.0289Z"
                :fill="color"
            />
        </svg>
    </div>
</template>
<script>
export default {
    name: "User",
    props: ["color"],
};
</script>
<style scoped>
svg {
    fill: var(--header-text-color);
}
</style>



// WEBPACK FOOTER //
// src/components/V2/svg/components/ArrowB.vue